/**
 * PRJ1417943 - Integration Accelerator
 * Dynamically loads agency validation rules from agencies config
 * Changed from static imports for centralized agency management
 */
// Agencies config
import agencies from '../../../../agency-config/agencies';

// Returns a rules object, using dynamic imports (but does not return a promise)
export function getAgencyRules() {
  const rules = {};
  const agenciesArr = Array.isArray(agencies) ? agencies : Object.values(agencies);
  agenciesArr.forEach(({ agency }) => {
    const { agencyShortName, importPath } = agency;
    const slug = String(agencyShortName || '').toLowerCase();
    if (importPath) {
      try {
        // Use require for synchronous dynamic import
        // eslint-disable-next-line global-require, import/no-dynamic-require
        const mod = require(`./${importPath.replace('./', '')}`);
        // rules[slug] = mod[slug] || mod.default || mod;
          Object.assign(rules, mod);
      } catch (e) {
        // Optionally log or handle missing module
      }
    } else {
      rules[slug] = {};
    }
  });
  return rules;
}
